'use client'

import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import MobileIcon from 'src/app/assets/icons/ico-mobile.svg'

export function OrientationMessage() {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <div className="race-loading-indicator-outer">
      <div className="race-loading-indicator orientation-message">
        <div className="race-loading-indicator__inner">
          <div className="orientation-icon">
            <MobileIcon />
          </div>
          <div className="text">
            <span className="primary">
              {t('This game is not optimized for mobile landscape orientation.')}
            </span>
            <span className="secondary">{t('Please rotate your device.')}</span>
          </div>
        </div>
      </div>
      <div className="loading-indicator__background">
        <img alt="" src="/assets/marbles-racetrack-loading-screen.webp" />
      </div>
    </div>
  )
}
